(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-selector/assets/javascripts/draw-selector.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-selector/assets/javascripts/draw-selector.js');
'use strict';

const {
  useEffect,
  useState,
  useCallback
} = React;
const {
  useSelector
} = ReactRedux;
const {
  useLocation,
  useHistory
} = ReactRouterDOM;
const {
  ForEach,
  If
} = svs.components.lbUtils.reactConditionals;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_AM
} = svs.components.lbUtils.useMediaQuery;
const {
  getAppendedPersistedSearchParams
} = svs.components.sport.tipsenShared;
const {
  TipsenModuleGameUrl
} = svs.components.sport.tipsenShared;
const {
  selectCurrentDrawsByProduct
} = svs.components.tipsen.selectors;
const {
  selectDrawProductIds
} = svs.components.tipsen.engine.selectors.engineSelectors;
const {
  DrawNav,
  DrawItem
} = svs.components.tipsen.drawselector;
const {
  selectActiveWallet
} = svs.components.tipsen.walletSelectors;
const {
  useContainerNavigation,
  useDrawItemPositions,
  useSwipe,
  useKeyboard
} = svs.components.tipsen.drawSelectorComponents.hooks;
const {
  WALLET_MARKETPLACE_PLAYER,
  WALLET_MARKETPLACE_RETAILER
} = svs.components.tipsen.wallet.walletType;
const {
  useLockedDraw
} = svs.components.tipsen.hooks;


const marketplaceWalletTypes = [WALLET_MARKETPLACE_PLAYER, WALLET_MARKETPLACE_RETAILER];
const DrawSelector = () => {
  const isLargeDevice = useMediaQuery(breakpoints.up(BREAKPOINT_AM));
  const [containerRef, setContainerRef] = useState();
  const [drawItemRefs, setDrawItemRefs] = useState([]);
  const draws = useSelector(selectCurrentDrawsByProduct);
  const selectedWallet = useSelector(selectActiveWallet);
  const drawProductIds = useSelector(selectDrawProductIds);
  const location = useLocation();
  const history = useHistory();
  const lockedDraw = useLockedDraw();
  const isExternalInspect = location.pathname.includes("/".concat(TipsenModuleGameUrl.EXTERNAL, "/granska"));
  const shouldDisableDrawSelector = lockedDraw;
  const {
    indexOfSelected,
    indexOfCentered,
    goToPrevious,
    goToNext,
    goToSelected,
    setCenteredIndex,
    setSelectedIndex
  } = useContainerNavigation(draws);
  const hasMarketplace = selectedWallet && marketplaceWalletTypes.includes(selectedWallet.type);
  const navStepSize = draws.length > 3 && isLargeDevice ? 2 : 1;
  const shouldUseSwipe = !shouldDisableDrawSelector || !hasMarketplace || draws.length < 1;
  const isCentered = useCallback(index => index === indexOfCentered, [indexOfCentered]);
  const isSelected = useCallback(index => index === indexOfSelected, [indexOfSelected]);
  const onSwipeLeft = useCallback(() => {
    if (shouldUseSwipe) {
      goToNext(false, navStepSize);
    }
  }, [goToNext, navStepSize, shouldUseSwipe]);
  const onSwipeRight = useCallback(() => {
    if (shouldUseSwipe) {
      goToPrevious(false, navStepSize);
    }
  }, [goToPrevious, navStepSize, shouldUseSwipe]);
  const {
    triggerContainerVisibility
  } = useDrawItemPositions(drawItemRefs, isLargeDevice, indexOfCentered, indexOfSelected, containerRef);
  useEffect(() => {
    let delayedTrigger;
    const _containerRef = containerRef;
    if (triggerContainerVisibility && containerRef) {
      delayedTrigger = setTimeout(() => {
        _containerRef.classList.add('draw-container-visible');
        _containerRef.classList.add('draw-container-use-transitions');
      }, 100);
    }
    return () => {
      if (delayedTrigger) {
        clearTimeout(delayedTrigger);
      }
    };
  }, [triggerContainerVisibility, containerRef]);
  const triggerRoute = useCallback((productId, drawNumber) => {
    let toParamsString = "?draw=".concat(drawNumber);
    if (drawProductIds.length > 1) {
      toParamsString = "".concat(toParamsString, "&product=").concat(productId);
    }
    const toParams = getAppendedPersistedSearchParams(location, toParamsString);
    history.push("?".concat(toParams));
  }, [location, drawProductIds.length, history]);
  const {
    onLinkKeyDown
  } = useKeyboard(drawItemRefs, indexOfCentered, triggerRoute);
  useSwipe(containerRef, onSwipeLeft, onSwipeRight);
  if (draws.length < 1) {
    return null;
  }
  const classList = ['draw-selector'];
  if (isLargeDevice) {
    classList.push('items-are-expandable', 'items-expand-horizontal');
  }
  const className = classList.join(' ');
  const selectedIsCentered = isSelected(indexOfCentered);
  const shouldShowArrowButtons = isLargeDevice && !hasMarketplace && !isExternalInspect;
  const isLeftDisabled = isCentered(0);
  const isRightDisabled = isCentered(draws.length - 1);
  return React.createElement("div", {
    className: className
  }, React.createElement("div", {
    className: "draw-selector-header"
  }, React.createElement(If, {
    condition: draws.length > 1
  }, React.createElement(DrawNav, {
    isGoToSelectedDisabled: selectedIsCentered,
    isLeftDisabled: isLeftDisabled,
    isRightDisabled: isRightDisabled,
    onGoToSelected: goToSelected,
    onNext: goToNext,
    onPrevious: goToPrevious,
    showArrowButtons: shouldShowArrowButtons
  }))), React.createElement("nav", {
    "aria-label": "Omg\xE5ngsv\xE4ljare",
    className: "draw-container",
    ref: containerRef => {
      setContainerRef(containerRef);
    }
  }, React.createElement(ForEach, {
    array: draws,
    render: (draw, index) => {
      if (!draw) {
        return null;
      }
      const {
        drawNumber,
        productId
      } = draw;
      return React.createElement(DrawItem, {
        draw: draw,
        index: index,
        isCentered: isCentered(index),
        isDisabled: shouldDisableDrawSelector && (draw.productId !== (lockedDraw === null || lockedDraw === void 0 ? void 0 : lockedDraw.productId) || draw.drawNumber !== (lockedDraw === null || lockedDraw === void 0 ? void 0 : lockedDraw.drawNumber)),
        isLargeDevice: isLargeDevice,
        isSelected: isSelected(index),
        key: "".concat(drawNumber, "_").concat(productId),
        onLinkKeyDown: onLinkKeyDown,
        onTriggerRoute: triggerRoute,
        ref: ref => {
          setDrawItemRefs(_drawItemRefs => {
            _drawItemRefs[index] = ref;
            return _drawItemRefs;
          });
        },
        setCenteredIndex: setCenteredIndex,
        setSelectedIndex: setSelectedIndex
      });
    }
  })));
};
setGlobal('svs.components.tipsen.drawselector.DrawSelector', DrawSelector);

 })(window);